import React, { Fragment, useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { formatCapital } from "../../../../utils/utils";
import { formatCuotasPlan } from "../../Convenios/Components/utils";
import { useDispatch } from "react-redux";
import { setLoading } from "../../../../redux/Loading/actions";
import { convenioService } from "../../../../_services/convenios.service";

const Convenio = ({ convenioId }) => {
  const [data, setData] = useState([]);
  const [deudas, setDeudas] = useState([]);
  const [monto, setMonto] = useState("");
  const [honorarios, setHonorarios] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    const getData = async () => {
      try {
        dispatch(setLoading(true));
        let response = await convenioService.getConvenio(convenioId);

        if (response?.mensaje) {
          dispatch(setLoading(false));
          setData({});
          return response.mensaje;
        }

        setData(response);
        dispatch(setLoading(false));
      }
      catch (err) {
        console.log(err);
        setData([]);
        dispatch(setLoading(false));
      }
    };

    getData();
  }, [convenioId]);


  useEffect(() => {
    if (data?.cuotas_plan) {
      setDeudas(formatCuotasPlan(data?.cuotas_plan));
    }
  }, [data]);

  useEffect(() => {
    if (data?.planes) {
      let planes = JSON.parse(data.planes);

      let total = planes.reduce((prev, current) => {
        return +prev + +current.monto;
      }, 0);

      if (total) {
        setMonto(total);
        setHonorarios(total * (+data.estporc || 1));
      }

    }
  }, [data]);


  return (
    <Table striped bordered hover>
      <tbody>
        <tr>
          <td className="convenio-data">DNI del firmante</td>
          <td>{data?.frm_dni}</td>
        </tr>
        <tr>
          <td className="convenio-data">Apellido y Nombre del firmante</td>
          <td>{data?.frm_nombre}</td>
        </tr>
        <tr>
          <td className="convenio-data">Dirección del firmante</td>
          <td>{data?.frm_dir}</td>
        </tr>
        <tr>
          <td className="convenio-data">Localidad del firmante</td>
          <td>{data?.frm_loc}</td>
        </tr>
        <tr>
          <td className="convenio-data">Teléfono del firmante</td>
          <td>{data?.frm_tel}</td>
        </tr>
        <tr>
          <td className="convenio-data">Celular del firmante</td>
          <td>{data?.frm_cel}</td>
        </tr>
        <tr>
          <td className="convenio-data">E-Mail del firmante</td>
          <td>{data?.frm_email}</td>
        </tr>
        <tr>
          <td className="convenio-data">Carácter del firmante</td>
          <td>{data?.firma_caracter_nombre}</td>
        </tr>
        <tr>
          <td className="convenio-data">Fecha de la firma</td>
          <td>{data?.format_confirma}</td>
        </tr>
        <tr>
          <td className="convenio-data">Estado</td>
          <td>{data?.estado_nombre}</td>
        </tr>
        <tr>
          <td>Resumen Deuda</td>
          <td>
            <Table striped bordered hover>
              <tbody>
                {data?.cuotas_plan && deudas.map((e) => {
                  return (
                    <Fragment key={`${e.recurso}${e.imponible}`}>
                      <tr className="mt-1">
                        <td><b>Recuso</b></td>
                        <td><b>Imponible</b></td>
                        <td><b>Estado</b></td>
                      </tr>
                      <tr>
                        <td>{e.recurso}</td>
                        <td>{e.imponible}</td>
                        <td>{e.estado}</td>
                      </tr>
                      <tr>
                        <td colSpan={3}>Alcance del Plan</td>
                      </tr>
                      {e.deudas.map((d) => {
                        return (
                          <tr key={`${e.imponible}${d.anio}`}>
                            <td colSpan={3}>{d.anio}: {d.cuotas?.length ? d.cuotas.sort((a,b) => a - b).map((r, i) => r ? r + `${i === (d.cuotas?.length - 1) ? "" : ", "}` : null) : ""}</td>
                          </tr>
                        );
                      })}
                    </Fragment>

                  );
                })}
              </tbody>
            </Table>
          </td>
        </tr>
        <tr>
          <td className="convenio-data">Monto</td>
          <td>{monto ? `$ ${formatCapital(monto)}` : ""}</td>
        </tr>
        <tr>
          <td className="convenio-data">Honorarios s/Deuda</td>
          <td>{honorarios ? `$ ${formatCapital(honorarios)}` : ""}</td>
        </tr>
        <tr>
          <td className="convenio-data">Gasto Fijo</td>
          <td>{data?.estgstfijo ? `$ ${data?.estgstfijo}` : ""}</td>
        </tr>
        <tr>
          <td className="convenio-data">Total Honorarios</td>
          <td>$ {formatCapital((+honorarios + +data?.estgstfijo))}</td>
        </tr>
        <tr>
          <td className="convenio-data">Forma de pago</td>
          <td>{data?.frmpg_nombre}</td>
        </tr>
        {data?.frmpg_nombre === "En Cuotas" ? <tr>
          <td className="convenio-data">Cuotas Pago Profesional</td>
          <td>{data?.cuotaspago}</td>
        </tr> : null}
      </tbody>
    </Table>
  );
};



export default Convenio;